import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Critere } from 'src/app/utils/interfaces/new/Critere';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { MedicPerso } from 'src/app/utils/interfaces/new/medic-perso.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
    providedIn: 'root'
})
export class MedicPersoService {

    private httpOptions = {
        withCredentials: true,
        observe: 'response' as 'response',
        headers: new HttpHeaders()
    };
    private uri = environment.basePath + "/personnalisation/medic-perso";

    constructor(
        private http: HttpClient,
        private _filtresService: FiltresService,
        private _snack: SnackbarService
    ) { }

    public async create(medic: MedicPerso): Promise<MedicPerso> {
        try {
            const res = await this.http.post(this.uri, medic, this.httpOptions).toPromise();
            const newMedic = res.body as MedicPerso;
            return newMedic;
        } catch (error) {
            console.log(error);
            this._snack.openSnackBar(error.error.message);
        }
    }

    public async find(filtre: Filtres = {
        perpage: -1,
        currentPage: 1,
        sortBy: 'libelle'
    }): Promise<Paginated<MedicPerso>> {
        try {
            this.httpOptions.headers = this._filtresService.setHeaders(filtre);
            const res = await this.http.get(this.uri, this.httpOptions).toPromise();
            const medics = res.body as MedicPerso[];
            const paginated: Paginated<MedicPerso> = {
                page: Number(res.headers.get('x-page')),
                perpage: Number(res.headers.get('x-per-page')),
                total: Number(res.headers.get('x-total')),
                objects: medics
            };
            return paginated;
        } catch (error) {
            this._snack.openSnackBar(error.error.message);
        }
    }

    public async update(medic: MedicPerso) {
        try {
            const res = await this.http.put(this.uri + "/" + medic.id, medic, this.httpOptions).toPromise();
            return;
        } catch (error) {
            this._snack.openSnackBar(error.error.message);
        }
    }

    public async findOne(medicId: string): Promise<MedicPerso> {
        try {
            const res = await this.http.get(this.uri + "/" + medicId, this.httpOptions).toPromise();
            const medic = res.body as MedicPerso;
            return medic;
        } catch (error) {
            this._snack.openSnackBar(error.error.message);
        }
    }

    public async delete(medicId: string) {
        try {
            const res = await this.http.delete(this.uri + "/" + medicId, this.httpOptions).toPromise();
            return;
        } catch (error) {
            this._snack.openSnackBar(error.error.message);
        }
    }
}
